import { LoaderService } from '@/services/loader.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  loaderService = inject(LoaderService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.match('version.*')) {
      return next.handle(req);
    }
    this.loaderService.loading();
    return next.handle(req).pipe(finalize(() => this.loaderService.loaded()));
  }
}
